import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { Site } from '../../../../models/site';
import { User } from '../../../../models/user';
import { Organization } from '../../../../models/organization';
import { SiteUserSettings } from '../../../../models/site-user-settings';
import { UserRole } from '../../../../enums/user-role';
import { UserTools } from '../../../../tools/user.tools';

import * as SiteActions from '../../../../features/site/site.actions';
import {
  selectSiteUserSettings,
  selectSiteUserSettingsLoading,
  selectSiteUserSettingsUpdating,
} from '../../../../features/site/site.selectors';


export type SiteSettingsSection =
  | 'notifications';


export interface SiteSettingsDialogData {
  site: Site;
  user: User;
  organization: Organization;
}


@Component({
  selector: 'site-settings-dialog',
  templateUrl: './site-settings-dialog.component.html',
  styleUrls: ['./site-settings-dialog.component.scss'],
  standalone: false,
})
export class SiteSettingsDialogComponent {

  selectedSection: SiteSettingsSection = 'notifications';

  readonly userSettings$ = this.store.select(
    selectSiteUserSettings
  );

  readonly userSettingsLoading$ = this.store.select(
    selectSiteUserSettingsLoading
  );

  readonly userSettingsUpdating$ = this.store.select(
    selectSiteUserSettingsUpdating
  );


  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: SiteSettingsDialogData,
    private dialogRef: MatDialogRef<SiteSettingsDialogComponent>,
    private store: Store,
  ) {
    this.loadUserSettings();
  }


  get canManageNotifications(): boolean {
    return UserTools.hasAnyRole(
      this.data.user,
      this.data.organization,
      [
        UserRole.BASIC,
        UserRole.ADMIN,
      ],
    );
  }


  selectSection(section: SiteSettingsSection): void {
    this.selectedSection = section;
  }


  onNotificationEmailsChange(enabled: boolean): void {
    const settings = new SiteUserSettings();

    settings.advancedFeaturesEmailNotifications = enabled;

    this.store.dispatch(
      SiteActions.updateUserSettings({
        organizationId: this.data.organization.id,
        siteId: this.data.site.id,
        settings,
      })
    );
  }


  close(): void {
    this.dialogRef.close();
  }


  private loadUserSettings(): void {
    this.store.dispatch(
      SiteActions.loadUserSettings({
        organizationId: this.data.organization.id,
        siteId: this.data.site.id,
      })
    );
  }

}
